/*
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  ASSET: Listicle Header Script
  Purpose: Opens the theme's existing menu drawer when the listicle header menu icon is clicked, so the page reuses the store's navigation instead of a second menu.
  Last updated: October 2026
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
*/

(() => {
  if (window.elListicleHeader) return;
  window.elListicleHeader = true;

  const THEME_MENU_TRIGGER = '.el-mobile-menu-button';

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-el-listicle-menu]');
    if (!button) return;
    const trigger = document.querySelector(THEME_MENU_TRIGGER);
    if (!trigger) return;
    event.preventDefault();
    trigger.click();
  });
})();